import type { PrecompiledResponse } from "~/types/precompiledResponse";

export default defineNuxtPlugin(() => {
  return {
    provide: {
      loadPrecompiledData: async (code: string) => {
        const data = getThemeData();

        const url = `${data.endpoints.server}/${code}/banche`;

                try {
                    const resp = await $fetch(url, {
                        method: "GET",
                    }) as PrecompiledResponse;

                    if (resp.order.StartRobot)
                        updateStateValue('pendingModal', true);

                    else if (resp.success == true)
                        return resp.order.step_precompile;

                    return resp;
                } catch (error) {
                    updateStateValue('errorModal', true);
                }
            },
        },
    };
});
